import { render, staticRenderFns } from "./member-certificates-dialog.vue?vue&type=template&id=823966d0&scoped=true"
import script from "./member-certificates-dialog.vue?vue&type=script&lang=js"
export * from "./member-certificates-dialog.vue?vue&type=script&lang=js"
import style0 from "./member-certificates-dialog.vue?vue&type=style&index=0&id=823966d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823966d0",
  null
  
)

export default component.exports